export class Transactions {
    static computerUnits: number = 96000;
    static microLamports: number = 5800000;
}